import type { LandingFunnelRow } from "@lingoshade/domain";

export interface FunnelFilters {
  source: string;
  campaign: string;
  content: string;
  device: string;
  country: string;
  excludeAutomated: boolean;
}
export function filterFunnelRows(
  rows: LandingFunnelRow[],
  filters: FunnelFilters,
): LandingFunnelRow[] {
  return rows.filter(
    (row): boolean =>
      (filters.source === "all" ||
        (row.source ?? row.referrerHost ?? "") === filters.source) &&
      (filters.campaign === "all" ||
        (row.campaign ?? "") === filters.campaign) &&
      (filters.content === "all" || (row.content ?? "") === filters.content) &&
      (filters.device === "all" || row.device === filters.device) &&
      (filters.country === "all" || (row.country ?? "") === filters.country) &&
      (!filters.excludeAutomated || row.traffic === "unclassified"),
  );
}
export function sumFunnelField(
  rows: LandingFunnelRow[],
  field:
    | "visits"
    | "views"
    | "shadowingOpened"
    | "dictationOpened"
    | "shadowingStarted"
    | "dictationStarted"
    | "practiced"
    | "registered",
): number {
  return rows.reduce((sum, row): number => sum + row[field], 0);
}
